let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("ffQaD"), load("kvRbA"), load("8X39V")]).then(() => parcelRequire('1s2AM'));